// extracted by mini-css-extract-plugin
module.exports = {"component":"EmbedProvider_component___Rlgt","loading":"EmbedProvider_loading__1d9WT"};